import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { skipOnboardingStep, updateAccountType, updateAccountWebsite } from 'services/api/onboarding';
import { fetchUser } from 'slices/auth/thunk';
import { AppDispatch, RootState } from 'store';
import { getErrorMessage } from 'utils/helpers';

const Website = () => {

    const [website, setWebsite] = useState('');
    const selectedAgencyId = useSelector((state: RootState) => state.auth.selectedAgencyId);
    const [processing, setProcessing] = useState(false);
    const [skipping, setSkipping] = useState(false);
    const dispatch: AppDispatch = useDispatch();

    const onContinue = async () => {
        if (!selectedAgencyId || !website) return;
        try {
            setProcessing(true);
            await updateAccountWebsite(selectedAgencyId, website);
            dispatch(fetchUser());
        } catch (error) {
            console.log(error);
            toast.error(getErrorMessage(error));
        } finally {
            setProcessing(false);
        }
    }

    const onSkip = async () => {
        try {
            if (!selectedAgencyId) return;
            setSkipping(true);
            await skipOnboardingStep(selectedAgencyId, 'website_url');
            dispatch(fetchUser());
        } catch (error) {
            console.log(error);
            toast.error(getErrorMessage(error));
        } finally {
            setSkipping(false);
        }
    }

    return (
        <div className='onboarding-step'>
            <h3>Add your website</h3>
            <div className="onboarding-step-field">
                <input type="text" className="onboarding-step__input__field" value={website} onChange={(e) => setWebsite(e.target.value)} placeholder='https://www.yourBrandWebsite.com' />
                <span className="onboarding-step__field__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M8.99991 11.9999H14.9999" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                        <path d="M9 18H8C4.68629 18 2 15.3137 2 12C2 8.68629 4.68629 6 8 6H9" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                        <path d="M15 6H16C19.3137 6 22 8.68629 22 12C22 15.3137 19.3137 18 16 18H15" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                </span>
            </div>
            <div className="onboarding-step-footer d-flex align-items-center gap-3 w-100 justify-content-center position-absolute  flex-column flex-md-row">
                <button className='btn skip-btn' onClick={onSkip} disabled={skipping} >{skipping ? 'Please wait...' : 'I don\'t have a website yet'}</button>
                <button className='btn btn-gradient' disabled={!website || processing} onClick={onContinue}>{processing ? 'Please wait...' : 'Continue'}</button>
            </div>
        </div>
    )
}

export default Website